/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Offline_Instruction_2Inputs */

const en_login_offline_instruction_2 = /** @type {(inputs: Login_Offline_Instruction_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visit <strong>https://app.closedcaptioncreator.com</strong> on a computer with an internet connection`)
};

const fr_login_offline_instruction_2 = /** @type {(inputs: Login_Offline_Instruction_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visitez <strong>https://app.closedcaptioncreator.com</strong> sur un ordinateur avec une connexion Internet`)
};

const de_login_offline_instruction_2 = /** @type {(inputs: Login_Offline_Instruction_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Besuchen Sie <strong>https://app.closedcaptioncreator.com</strong> auf einem Computer mit Internetverbindung.`)
};

const it_login_offline_instruction_2 = /** @type {(inputs: Login_Offline_Instruction_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visita <strong>https://app.closedcaptioncreator.com</strong> su un computer con una connessione Internet`)
};

const ru_login_offline_instruction_2 = /** @type {(inputs: Login_Offline_Instruction_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Перейдите по ссылке <strong>https://app.closedcaptioncreator.com</strong> на компьютере с подключением к интернету.`)
};

const es_login_offline_instruction_2 = /** @type {(inputs: Login_Offline_Instruction_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visita <strong>https://app.closedcaptioncreator.com</strong> en una computadora con conexión a Internet.`)
};

const zh_cn2_login_offline_instruction_2 = /** @type {(inputs: Login_Offline_Instruction_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请在连接互联网的电脑上访问 <strong>https://app.closedcaptioncreator.com</strong>`)
};

const ja_login_offline_instruction_2 = /** @type {(inputs: Login_Offline_Instruction_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`インターネットに接続されたパソコンで <strong>https://app.closedcaptioncreator.com</strong> にアクセスしてください。`)
};

const hi_login_offline_instruction_2 = /** @type {(inputs: Login_Offline_Instruction_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इंटरनेट कनेक्शन वाले कंप्यूटर पर <strong>https://app.closedcaptioncreator.com</strong> पर जाएं`)
};

const pt_pt2_login_offline_instruction_2 = /** @type {(inputs: Login_Offline_Instruction_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acesse <strong>https://app.closedcaptioncreator.com</strong> em um computador com conexão à internet.`)
};

/**
* | output |
* | --- |
* | "Visit <strong>https://app.closedcaptioncreator.com</strong> on a computer with an internet connection" |
*
* @param {Login_Offline_Instruction_2Inputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const login_offline_instruction_2 = /** @type {((inputs?: Login_Offline_Instruction_2Inputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Offline_Instruction_2Inputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_login_offline_instruction_2(inputs)
	if (locale === "de") return de_login_offline_instruction_2(inputs)
	if (locale === "it") return it_login_offline_instruction_2(inputs)
	if (locale === "ru") return ru_login_offline_instruction_2(inputs)
	if (locale === "es") return es_login_offline_instruction_2(inputs)
	if (locale === "zh-CN") return zh_cn2_login_offline_instruction_2(inputs)
	if (locale === "ja") return ja_login_offline_instruction_2(inputs)
	if (locale === "hi") return hi_login_offline_instruction_2(inputs)
	if (locale === "pt-PT") return pt_pt2_login_offline_instruction_2(inputs)
	return en_login_offline_instruction_2(inputs)
});